module.exports = __webpack_public_path__ + "img/block_2.b81a0c3c.webp";